var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.serviceid == 35445 ||
    _vm.serviceid == 20152 ||
    _vm.serviceid == 20153 ||
    _vm.serviceid == 20154 ||
    _vm.serviceid == 47694
    ? _c(
        "a",
        {
          attrs: {
            href: "javascript:0;",
            "data-bs-toggle": "popover",
            title: _vm.getTitleText,
            "data-bs-trigger": "hover",
            "data-bs-placement": "top",
            "data-bs-html": "true",
            "data-bs-content": _vm.getServiceText
          }
        },
        [_c("i", { staticClass: "fa-sharp fa-light fa-info-circle" })]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }